<div class="cea-card card-product-spotlight mb-4">
    <div class="card-product-spotlight-overlay">
        <span class="card-product-spotlight-indicator"></span>
        <div class="card-body card-product-spotlight-body" style="max-width: 100%;">
            <div class="row">
                <div class="col-xs-12 col-md-6 set-mobile-center">
                    <div [class]="getSpotlightTitleClass()">
                        <span *ngIf="policytype === modules.homeowner && !isPolicyTypeChoice">
                                {{"GLOBAL.Homeowners" | translate}}

                                <app-cea-help-button *ngIf="policytype === modules.homeowner"
                                                      [stype]="'spotlight'"
                                                      [title]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.TITLE'"
                                                      [text1]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH1'"
                                                      [text2]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH2'">
                                </app-cea-help-button>

                            </span>
                            <span *ngIf="policytype === modules.homeowner && isPolicyTypeChoice">
                                {{"GLOBAL.Homeowners Choice" | translate}}

                                <app-cea-help-button *ngIf="policytype === modules.homeowner"
                                                      [stype]="'spotlight'"
                                                      [title]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.TITLE'"
                                                      [text1]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH1'"
                                                      [text2]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH2'">
                                </app-cea-help-button>

                            </span>

                            <span *ngIf="policytype === modules.renter">{{"GLOBAL.Renters" | translate}}</span>
                            <span *ngIf="policytype === modules.condo">{{"GLOBAL.CONDO_OWNERS" | translate}}</span>
                            <span *ngIf="policytype === modules.mobilehome && !isPolicyTypeChoice">
                                {{"GLOBAL.Mobilehome" | translate}}

                                <app-cea-help-button *ngIf="policytype === modules.mobilehome"
                                                      [stype]="'spotlight'"
                                                      [title]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.TITLE'"
                                                      [text1]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH1'"
                                                      [text2]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH2'">
                                </app-cea-help-button>

                            </span>

                            <span *ngIf="policytype === modules.mobilehome  && isPolicyTypeChoice">
                                {{"GLOBAL.Mobilehome Choice" | translate}}

                                <app-cea-help-button *ngIf="policytype === modules.mobilehome"
                                                      [stype]="'spotlight'"
                                                      [title]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.TITLE'"
                                                      [text1]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH1'"
                                                      [text2]="'HOMEOWNERS.CALCULATIONS.HELP.DIFFERENCE.PARAGRAPH2'">
                                </app-cea-help-button>

                            </span>
                    </div>
                    <div class="title-detail-font row">
                        <div class="col"  style="white-space: nowrap;">
                            {{"HOMEOWNERS.CALCULATIONS.ZIPCODE" | translate}}
                            : <span class="text-secondary fw-bold">
                                {{zipCode}}
                            </span>
                        </div>
                        
                    </div>
                    <div class="title-detail-font row">
                        <div class="col" style="white-space: nowrap;">
                            {{"HOMEOWNERS.CALCULATIONS.EFFECTIVE_POLICY_START" | translate}}
                            : <span class="text-secondary fw-bold">
                                {{startYear}}
                            </span>
                        </div>                        
                    </div> 
                </div>
                <div class="col-xs-12 col-md-6 text-center">
                    <div class="gauges-container">
                        <ngx-gauge *ngIf="processing == true" class="fakeGuage" type="semi" value="-" size="240"
                            [max]="100" [thick]="36" backgroundColor="rgb(255, 255, 255)"
                            foregroundColor="rgb(138, 220, 255)">
                        </ngx-gauge>
                        <ngx-gauge *ngIf="processing == false" height="138" class="actualGuage" type="semi" size="240"
                            [value]="gaugeValue" [max]="'400'" [thick]="36" prepend="$"
                            backgroundColor="rgb(255, 255, 255)" foregroundColor="rgb(138, 220, 255)">
                        </ngx-gauge>
                    </div>
                    <div class="gauge-title" *ngIf="processing == false">
                        {{ "HOMEOWNERS.CALCULATIONS.ESTIMATED_MONTHLY_PREMIUM" | translate}}
                    </div>
                    <div class="gauge-subtitle" *ngIf="processing == false && policytype !== modules.homeowner">
                        {{ "HOMEOWNERS.CALCULATIONS.ANNUAL_PREMIUM" | translate}}
                        : 
                        <span class="text-secondary fw-bold">
                            ${{annualPremium | number : '1.2-2'}}
                        </span>
                    </div>
                    <div class="gauge-subtitle"
                        *ngIf="processing == false && policytype === modules.homeowner && annualPremium !== undefined">
                        {{ "HOMEOWNERS.CALCULATIONS.ANNUAL_PREMIUM" | translate}}
                        : 
                        <span class="text-secondary fw-bold">
                            ${{annualPremium | number : '1.2-2'}}
                        </span>
                    </div>
                    <div *ngIf="processing == true" class="gauge-title">
                        {{ "HOMEOWNERS.CALCULATIONS.ESTIMATE_PENDING" | translate}}...
                    </div>
                </div>
            </div>
            <span id="ready" *ngIf="processing === false"></span>
        </div>  
    </div>
</div>
